import { RadioButtonGroupInput } from "react-admin";

const OneZeroInput = ({ ...props }) => (
  <RadioButtonGroupInput
    {...props}
    choices={[
      { id: "1", name: "Enabled" },
      { id: "0", name: "Disabled" },
    ]}
  />
);

export default OneZeroInput;
